import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Item } from './item.model';
import { ResponseWrapper, createRequestOption } from '../../shared';
import { API } from '../../shared/constants/api.constants';
import * as _ from 'lodash';
import { AuthServerProvider } from '../../shared/auth/auth-jwt.service';

@Injectable()
export class ItemService {
    private resourceSymbolsUrl = API.host + 'invoices/filter-invoice-symbol';

    constructor
    (
        private http: Http,
        private authServerProvider: AuthServerProvider
    ) 
    { }
    
    getSymbols(invoiceTemplateId): Observable<ResponseWrapper> {
        return this.http.get(this.resourceSymbolsUrl + '/' + invoiceTemplateId).map((res: Response) => {
            const jsonResponse = res.json().data;
            return new ResponseWrapper(res.headers, jsonResponse, res.status);
        });
    }

}
